import React, { useContext, useEffect, useState } from 'react';
import { UserProfileContext } from '../context';
import { apiService } from 'utils/api';
import CardWithHeader from 'components/base/cards/card-with-header';

type BrandMealType = {
  name: string;
  order_length: number;
};

type PayloadType = {
  start_date: Date;
  end_date: Date;
};

const baseUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;

const getMeals = async (id: string, data: PayloadType) => {
  const res = await apiService.get(`user/one/meals/${id}`, { params: data, baseUrl });
  return res.data.data;
};
const getBrands = async (id: string, data: PayloadType) => {
  const res = await apiService.get(`user/one/brands/${id}`, { params: data, baseUrl });
  return res.data.data;
};

const UserStats = ({ id }: { id: string }) => {
  const [topBrands, setTopBrands] = useState([] as BrandMealType[]);
  const [topMeals, setTopMeals] = useState([] as BrandMealType[]);
  const [loading, setLoading] = useState(false);

  const { filters } = useContext(UserProfileContext);

  const getStats = async () => {
    const { startDate: start_date, endDate: end_date } = filters.date;
    const payload = { start_date, end_date };
    setLoading(true);
    const [mealRes, brandRes] = await Promise.all([getMeals(id, payload), getBrands(id, payload)]);

    let brands: BrandMealType[] = brandRes?.map((brand: any) => ({
      name: brand?.brand?.name,
      order_length: brand?.orders.length
    }));

    brands = brands?.sort((a, b) => b?.order_length - a?.order_length)?.splice(0, 10);

    let meals: BrandMealType[] = mealRes?.selected_brands?.map((meal: any) => ({
      name: meal?.meal?.name,
      order_length: meal?.orders_length
    }));

    meals = meals?.sort((a, b) => b?.order_length - a?.order_length)?.splice(0, 10);

    setTopBrands(brands);
    setTopMeals(meals);
    setLoading(false);
  };

  useEffect(() => {
    getStats();
  }, [filters]);
  return (
    <>
      <CardWithHeader title='top ordered items' className='max-w-[unset]'>
        {loading ? (
          <p>Loading...</p>
        ) : topMeals.length == 0 ? (
          '-'
        ) : (
          topMeals?.map(({ name, order_length }, i) => (
            <div key={i}>
              <p key={i}>
                {name} ({`${order_length} ${order_length > 1 ? 'orders' : 'order'}`})
              </p>
            </div>
          ))
        )}
      </CardWithHeader>
      <CardWithHeader title='top brands' className='max-w-[unset]'>
        {loading ? (
          <p>Loading...</p>
        ) : topMeals.length == 0 ? (
          '-'
        ) : (
          topBrands?.map(({ name, order_length }, i) => (
            <div key={i}>
              <p key={i}>
                {name} ({`${order_length} ${order_length > 1 ? 'orders' : 'order'}`})
              </p>
            </div>
          ))
        )}
      </CardWithHeader>
    </>
  );
};

export default UserStats;
